export default __webpack_public_path__ + "static/Prom_Visiomate_Profile-3d27a0334966fb798490a9c5fff992c1.pdf";